module.exports = __webpack_public_path__ + "img/34ne.7f7ab0e3.svg";